// components/markdown/index.ts
import { Highlight } from './Highlight';
import { Plot } from './Plot';
import { Alert } from './Alert';
import { PreviewComponent } from './Preview';
import { Tooltip } from './Tooltip';
import type { CustomComponent } from './types';
import { Pre } from './Pre';
import { GoogleSearch } from './GoogleSearch';
import NetworkGraph from './Network';
import { Image } from './Image'; 
import { Svg } from './SVG';
import { Code } from './Code';
import { ToolConfirmation } from './ToolConfirmation';
import { DynamicUI } from './DynamicUI';
import { Artifact } from './Artifact';
import { AssistantLink } from './AssistantLink';
import { AssistantResponse } from './AssistantResponse';

// Re-export the components and types
export * from './Highlight';
export * from './Plot';
export * from './types';
export * from './Alert';
export * from './Preview';
export * from './Tooltip';
export * from './Pre';
export * from './GoogleSearch';
export * from './Network';
export * from './Image';
export * from './SVG';
export * from './ToolConfirmation';
export * from './DynamicUI';
export * from './Artifact';
export * from './AssistantLink';
export * from './AssistantResponse';

// Register all components with both cases supported
// don't use <div> in components 
export const markdownComponents: Record<string, CustomComponent> = {
  // Regular lowercase versions
  highlight: Highlight,
  plot: Plot,
  alert: Alert,
  preview: PreviewComponent,
  tooltip: Tooltip,
  pre: Pre,
  googlesearch: GoogleSearch,
  networkgraph: NetworkGraph,
  img: Image,
  image: Image,
  svg: Svg,
  code: Code,
  toolconfirmation: ToolConfirmation,
  'dynamic-ui': DynamicUI as CustomComponent,
  dynamicui: DynamicUI as CustomComponent,
  artifact: Artifact as CustomComponent,
  a: AssistantLink,
  assistantresponse: AssistantResponse,


  // Optional: PascalCase versions if you want to support both casings
  Highlight: Highlight,
  Plot: Plot,
  Alert: Alert,
  Preview: PreviewComponent,
  Tooltip: Tooltip,
  Pre: Pre,
  NetworkGraph: NetworkGraph,
  GoogleSearch: GoogleSearch,
  Img: Image,
  Image: Image,
  Code: Code,
  Svg: Svg,
  ToolConfirmation: ToolConfirmation,
  DynamicUI: DynamicUI as CustomComponent,
  'Dynamic-UI': DynamicUI as CustomComponent,
  Artifact: Artifact as CustomComponent,
  A: AssistantLink,
  AssistantResponse: AssistantResponse,

};

export default markdownComponents;
